import React, { useMemo, useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import { isArray, isEmpty, isNumber, isEqual } from 'lodash';
import * as Yup from 'yup';
import { Form } from '@unform/web';

import { Table } from '~/components';
import { Input } from '~/components/Form/'
import { SelectDataInTable } from '~/componentslocal'
import { t, number } from '~/helpers';
import api from '~/services/api';
import { changeQuotas } from '~/store/modules/organRegistration/actions';

import * as S from './styles';

export default function Cota({ organ }) {
  const [itemsQuote, setItemsQuote] = useState([]);
  const [unity, setUnity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exib_justificativa, setExib_justificativa] = useState('');

  const [prod_cotas_distribuidas, setProd_cotas_distribuidas] = useState({})


  const userInfo = useSelector((state) => state.user)

  const dispatch = useDispatch();

  const { quotas } = useSelector((state) => state.organRegistration);


  const cellsQuote = useMemo(
    () => [
      { id: 'prod_codigo', label: 'Código' },
      { id: 'prod_descricao', label: 'Produto' },
      {
        id: 'cota_total',
        label: 'Saldo Estoque',
        format: (value) => isNumber(value) ? number(value, 1) : 'A confirmar...',
      },
      {
        id: 'coor_cota',
        label: 'Cota Distribuir',
        format: (value) => number(value, 1),
      },
      { id: 'coor_saldo', label: 'Saldo Cota', format: (value) => isNumber(value) ? number(value, 1) : 'A confirmar...' },
    ],
    []
  );

  const cellsUnity = useMemo(
    () => [
      { id: 'unid_codigo', label: 'Unidade' },
      { id: 'coun_cota', label: 'Cota', format: (value) => number(value, 1),  align: 'right' },
      { id: 'coun_saldo', label: 'Saldo Cota', format: (value) => number(value, 1), align: 'right' },
    ],
    []
  );

  const fieldsQuote = useMemo(
    () => [
      {
        id: 'prod_codigo',
        label: 'Produto',
        type: 'select',
        options: itemsQuote,
        disabled: true,
      },
      {
        id: 'coor_cota',
        label: 'Cota',
        type: 'number',
      },
      {
        id: 'coor_justificativa',
        label: 'Justificativa',
        type: 'textarea',
      }
    ],
    [itemsQuote]
  );

  const schemaQuote = useMemo(
    () => ({
      prod_codigo: Yup.number()
        .nullable()
        .required(t('s.geral.validacao.campoobrigatorio')),
      coor_cota: Yup.number()
        .nullable()
        .required(t('s.geral.validacao.campoobrigatorio')),
      coor_justificativa: Yup.string()
        .test('Teste caracteres', 'Caractere(s) inválido(s)', (value) => handleValidJustificativa(value))
    }),
    []
  );

  const handleValidJustificativa = useCallback((value) => {

    const regex1 = /[('")]/;

    if (regex1.test(value)) {
      return false;
    }
    return true;

  }, [])

  const handleGetAPIPossiblesQuote = useCallback(async () => {
    try {
      setIsLoading(true);

      const { data } = await api.get(
        `orgaos/cotas/possiveis/${organ}`
      );

      await setItemsQuote(
        data.map((item) => ({
          ...item,
          id: item.prod_codigo,
          label: item.prod_descricao,
          value: item.prod_codigo,
        }))
      );


    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setIsLoading(false);
    }
  }, [organ]);

  const handleGetCotasDistribuidas = useCallback((cotas) => {
    let cotas_distribuidas
    if (!isEmpty(cotas)) {
      cotas_distribuidas = cotas.reduce((valorAtual, novoValor,) => {
        return Number(novoValor.cove_cota) + Number(valorAtual);
      }, [0])

      setProd_cotas_distribuidas(cotas_distribuidas)

    } else {
      setProd_cotas_distribuidas(0)
    }

  }, [])

  const handleGetAPIUnity = useCallback(async (value) => {
    try {
      setLoading(true);
      setExib_justificativa(value.coor_justificativa)

      const { data } = await api.get(
        `orgaos/cotas/unidades/${value.orga_codigo}/${value.prod_codigo}`
      );
      handleGetCotasDistribuidas(data)
      setUnity(data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, []);

  const handleSerializeQuote = useCallback(
    (value) => {
      let objectSend = {
        ...itemsQuote.find((i) => i.prod_codigo === value.prod_codigo),
        ...value,
        cota_total: 'A confirmar...',
        coor_saldo: 'A confirmar',
        novo_cota_total: Number(value.coor_cota) + Number(prod_cotas_distribuidas),
        novo_coor_saldo: Number(value.coor_cota),
        coor_justificativa: value.coor_justificativa ?? '',
      }

      return objectSend
    },
    [itemsQuote, prod_cotas_distribuidas]
  );

  const handleChangeQuotes = useCallback((values) => {
    setExib_justificativa('')
    if (!isEqual(values, quotas)) {
      toast.warn('A alteração só será salva após o clique no botão "Confirmar"')
    }
    dispatch(changeQuotas(values));

  }, [quotas]);

  useEffect(() => {
    handleGetAPIPossiblesQuote();
  }, []);



  return (
    <S.Container>
      <SelectDataInTable
        radio
        cells={cellsQuote}
        items={itemsQuote}
        fields={fieldsQuote}
        schema={schemaQuote}
        initials={quotas}
        title="Cota do Órgão"
        unique="prod_codigo"
        isIgnore="prod_codigo"
        maxWidth="xs"
        onChanged={handleChangeQuotes}
        onField={handleSerializeQuote}
        onRow={handleGetAPIUnity}
        loading={isLoading}
        userPerfil={userInfo.profile}
        cota
      />
      {exib_justificativa && <Form>
        <Input
          name="justificativa_exib"
          label="Justificativa"
          disabled
          value={exib_justificativa}
          multiline
          rows={4}
        />
      </Form>}




      <Table
        noButton
        title="Unidades"
        unique="[unid_codigo, prod_codigo]"
        cells={cellsUnity}
        data={unity}
        loading={loading}
        onCallback={() => undefined}
      />
    </S.Container>
  );
}

Cota.propTypes = {
  organ: PropTypes.number.isRequired,
};
